import { LanPendingIcon } from './LanPendingIcon';

/**
 * author: Simran
 * id B5E302E3-DF81-430E-AAE0-4CAF44AFAD00
 * name lan-pending
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lan-pending.svg
 * tags
 */
export const LocalAreaNetworkPendingIcon = LanPendingIcon;
export default LocalAreaNetworkPendingIcon